import { useCallback, useMemo } from 'react';
import useLibTracker from 'personalization-lib/hooks/tracking/library/useLibTracker';
import { BUTTON_CLICK_ACTIONS, LIBRARY_USAGE_EVENTS } from 'personalization-lib/constants/tracking/libEvents';
const useButtonClickTracker = args => {
  const track = useLibTracker(LIBRARY_USAGE_EVENTS.BUTTON_CLICK);
  const createButtonClickTracker = useCallback(action => () => track(Object.assign({
    action
  }, args)), [track, args]);
  return useMemo(() => ({
    backToPersonalization: createButtonClickTracker(BUTTON_CLICK_ACTIONS.backToPersonalization),
    variantSelect: createButtonClickTracker(BUTTON_CLICK_ACTIONS.variantSelect),
    createPersonalization: createButtonClickTracker(BUTTON_CLICK_ACTIONS.createPersonalization),
    createPersonalizationWithAi: createButtonClickTracker(BUTTON_CLICK_ACTIONS.createPersonalizationWithAi)
  }), [createButtonClickTracker]);
};
export default useButtonClickTracker;